"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function LoginBlock() {
    const { t } = (0, i18n_1.useTranslation)();
    const bridge = (0, bridge_1.useBridge)();
    const handleContinue = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.authenticate();
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'LoginBlock_Container', children: [(0, jsx_runtime_1.jsx)(WrapperSvgLogo, { "data-e2e": 'LoginBlock_WrapperSvgLogo', children: (0, jsx_runtime_1.jsx)(ui_1.SvgLogo, { "data-e2e": 'LoginBlock_SvgLogo' }) }), (0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'LoginBlock_Title', children: t(i18n_1.Strings.popups.noAccess.title) }), (0, jsx_runtime_1.jsx)(Text, { "data-e2e": 'LoginBlock_Text', children: t(i18n_1.Strings.popups.noAccess.description) }), (0, jsx_runtime_1.jsx)(Button, { onClick: handleContinue, "data-e2e": 'LoginBlock_Button', children: t(i18n_1.Strings.popups.noAccess.button) })] }));
}
exports.default = LoginBlock;
const WrapperSvgLogo = styled_components_1.default.div `
  margin-top: 32px;
`;
const Container = styled_components_1.default.div `
  background: ${props => props.theme.white};
  border: 8px solid;
  border-color: #dddddd;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  width: 384px;
  height: 300px;
`;
const Title = styled_components_1.default.h2 `
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 16px;
`;
const Text = styled_components_1.default.p `
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 32px;
`;
const Button = styled_components_1.default.button `
  background: #007398;
  color: ${props => props.theme.white};
  border: none;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 16px;
  width: 302px;
  height: 52px;

  &:hover {
    background: #005f7a;
  }
`;
